{{if value.isShowTitle && value.isShowTitle != 'false' && value.isShowTitle != '0'}}
<li class="nav-item {{style.styleType == 'custom' ? style.fontSize: ''}}"
    style="{{style.styleType == 'default' ? '': 'color:'+style.color}}">
    {{if isDesign}}
        <span class="nav-text">{{value.title}}</span>
    {{else}}
        {{if value.type == 2 || value.type == 3 || value.type == 4 || value.type == 6 || value.type == 7 || (value.type == 100 && (value.linkType == 'custom' && value.link || value.linkType == 'system' && value.href.url))}}
        <a class="goto-link" href="{{value.link}}" {{value.linkType == 'custom' ? 'target="_blank"' : ''}}>
            <span class="nav-text">{{value.title}}</span>
        </a>
        {{else}}
        <span class="nav-text">{{value.title}}</span>
        {{/if}}
    {{/if}}

    {{if value.subItems && value.subItems.length}}
    <ul class="nav-child">
        {{each value.subItems $value2 $index2}}
        {{if $value2.isShowTitle && $value2.isShowTitle != 'false' && $value2.isShowTitle != '0'}}
        <li class="nav-item {{style2.styleType == 'custom' ? style2.fontSize: ''}}"
            style="{{style2.styleType == 'default' ? '': 'color:'+style2.color}}">
            {{if isDesign}}
                <span class="nav-text">{{$value2.title}}</span>
            {{else}}
                {{if $value2.type == 2 || $value2.type == 3 || $value2.type == 4 || $value2.type == 6 || $value2.type == 7 || ($value2.type == 100 && ($value2.linkType == 'custom' && $value2.link || $value2.linkType == 'system' && $value2.href.url))}}
                <a class="goto-link" href="{{$value2.link}}" {{$value2.linkType == 'custom' ? 'target="_blank"' : ''}}>
                    <span class="nav-text">{{$value2.title}}</span>
                </a>
                {{else}}
                <span class="nav-text">{{$value2.title}}</span>
                {{/if}}
            {{/if}}
        </li>
        {{/if}}
        {{/each}}
    </ul>
    {{/if}}
</li>
{{/if}}
